var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDebijenkorf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bijenkorf") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bijenkorf",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F2CD02",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9282443,11 L15.0056578,21.499057 L15,42.5066008 L31.9282443,53 L48.7678491,42.5594073 L48.7678491,21.4537943 L31.9282443,11 Z M30.4383476,48.4643018 L17.9137854,40.6923215 L17.9194432,23.3227661 L30.4383476,15.5507858 L30.4383476,17.5970364 C27.7471037,17.9949708 24.2241581,21.1709026 24.2241581,25.5010328 L24.2166143,32.5450382 L19.5319264,32.5469241 L19.5319264,40.3245622 L30.4383476,40.3245622 L30.4383476,48.4643018 L30.4383476,48.4643018 Z M33.3389313,48.4925909 L33.3464751,37.1769196 L22.436282,37.1882353 L22.4325101,35.683251 L27.1303996,35.685137 L27.1303996,25.6160754 C27.1247418,23.0285586 29.0710373,20.5202515 32.1922766,20.5202515 L33.3408172,20.5202515 L33.3464751,15.5074091 L45.8578357,23.2699596 L45.8616075,40.7356982 L33.3389313,48.4925909 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebijenkorf);
export default __webpack_public_path__ + "static/media/debijenkorf.2c2a40df15eab5af261e4a8499e3bdfe.svg";
export { ForwardRef as ReactComponent };